// The "Güçlü ve zayıf yönler" quadrant: score on one axis, time on the other.
//
// The score axis is the platform mastery line (product decision P5, 2026-10-21), read from the backend through
// getMasteryThreshold() — the same line the learning path uses. It used to be the class average clamped to 50–80,
// so in a weak class a %55 outcome could land among the "strong" ones. The time axis stays the class average
// clamped to 30–120 s.
import { getMasteryThreshold } from "../constants/MasteryConstants";

const MIN_TIME_LINE_SECONDS = 30;
const MAX_TIME_LINE_SECONDS = 120;

export const quadrantScoreLine = (): number => getMasteryThreshold();

/** An outcome exactly on the line counts as above it, like mastery. */
export const isAtOrAboveScoreLine = (scorePercentage: number): boolean =>
  scorePercentage >= getMasteryThreshold();

/** The class-average time line, clamped to 30–120 s; undefined when there is no timed row. */
export const clampTimeLine = (averageTimeSpentSeconds: number | undefined): number | undefined =>
  averageTimeSpentSeconds == null || Number.isNaN(averageTimeSpentSeconds)
    ? undefined
    : Math.max(MIN_TIME_LINE_SECONDS, Math.min(MAX_TIME_LINE_SECONDS, averageTimeSpentSeconds));
